import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Create AuthContext
const AuthContext = createContext();

// Custom hook for easy access to AuthContext
export const useAuth = () => useContext(AuthContext);

// AuthProvider Component
export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [userRole, setUserRole] = useState(localStorage.getItem("userRole"));
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedToken = localStorage.getItem("token");

    if (location.pathname === "/" && storedToken) {
      navigate("/dashboard");
    }

    if (location.pathname !== "/" && !storedToken) {
      navigate("/");
    }
  }, [location.pathname, navigate]);

  const login = (newToken, role) => {
    localStorage.setItem("token", newToken);
    localStorage.setItem("userRole", role);
    setToken(newToken);
    setUserRole(role);
    navigate("/dashboard");
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    setToken(null);
    setUserRole(null);
    navigate("/");
  };

  return (
    <AuthContext.Provider value={{ token, userRole, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;